// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qmLYC"};
module.exports.__checksum = "89e29ed3bfb6"